const CLS_CACHE_KEY = "desert_eye_cls_v3";
const CLS_CACHE_TTL = 24 * 60 * 60 * 1000;
const DEEP_CACHE_KEY = "desert_eye_deep_v5";
const DEEP_CACHE_TTL = 48 * 60 * 60 * 1000;
const IDEA_CACHE_KEY = "desert_eye_idea_v1";
const IDEA_CACHE_TTL = 48 * 60 * 60 * 1000;

export function loadClsCache() {
  try { const r = localStorage.getItem(CLS_CACHE_KEY); if (!r) return {}; const { data, ts } = JSON.parse(r); return Date.now() - ts > CLS_CACHE_TTL ? {} : data; } catch { return {}; }
}

export function loadDeepCache() {
  try { const r = localStorage.getItem(DEEP_CACHE_KEY); if (!r) return null; const { data, ts } = JSON.parse(r); return Date.now() - ts > DEEP_CACHE_TTL ? null : data; } catch { return null; }
}

export function saveDeepCache(d) {
  try { localStorage.setItem(DEEP_CACHE_KEY, JSON.stringify({ data: d, ts: Date.now() })); } catch {}
}

export function loadIdeaCache() {
  try { const r = localStorage.getItem(IDEA_CACHE_KEY); if (!r) return null; const { data, ts } = JSON.parse(r); return Date.now() - ts > IDEA_CACHE_TTL ? null : data; } catch { return null; }
}

export function saveIdeaCache(d) {
  try { localStorage.setItem(IDEA_CACHE_KEY, JSON.stringify({ data: d, ts: Date.now() })); } catch {}
}
